import { atom } from "recoil";

const appointmentDetailsAtom = atom({

    key:"appointmentDetails",
    default: {}

});

export default appointmentDetailsAtom;